<script>
  import { client } from "sanityClient.js";
  import { _ as t } from "svelte-i18n";

  import Workshop from "./Workshop.svelte";
  import LoginAccount from "../events/LoginAccount.svelte";

  import { getContext } from "svelte";
  import { query } from "svelte-apollo";
  import { client as apolloClient } from "apollo.js";
  import { CONTENT_QUERY } from "../events/queries";
  import ConfirmModal from "components/ConfirmModal.svelte";
  import LoginModal from "LoginModal.svelte";
  import { loginUser, forgotPassword } from "login.js";
  import { currentLang } from "stores.js";
  import { registerToEvent, unregisterFromEvent } from "../events/actions";

  export let appLogin;
  export let appLogout;

  const registrations = query(apolloClient, { query: CONTENT_QUERY });

  const workshopQuery =
    '*[_type == "workshop"] | order(date asc) {_id, title, teaser, date, program}';
  const params = {};
  const workshops = client.fetch(workshopQuery, params);

  // REGISTRATION LOGIC

  const { open, close } = getContext("simple-modal");
  const handleUnregister = (e) => {
    const { eventId } = e.detail;
    unregisterFromEvent(eventId, $currentLang, "workshop").then(() => {
      registrations.refetch();
      open(ConfirmModal, {
        title: $t("event.unregistrationConfirmation"),
        text: $t("event.unregistrationConfirmationDetail"),
        onClose: () => {
          close();
        },
      });
    });
  };

  const handleRegister = (e) => {
    const { eventId } = e.detail;
    registerToEvent(eventId, $currentLang, "workshop").then((response) => {
      if (response.data.registerToEvent.sentMail) {
        open(ConfirmModal, {
          title: $t("event.registrationConfirmation"),
          text: $t("event.registrationConfirmationDetail"),
          onClose: () => {
            close();
          },
        });
      }
      registrations.refetch();
    });
  };

  const handleLoginAndRegister = (e) => {
    e.preventDefault();
    e.stopPropagation();

    open(LoginModal, {
      onLogin: (session) => {
        appLogin(session.token);
        close();
        setTimeout(() => {
          handleRegister(e);
        }, 1000);
      },
      onClose: () => {
        close();
      },
      loginUser: loginUser,
      forgotPassword: forgotPassword,
    });
  };
</script>

<LoginAccount {appLogin} {appLogout} />
<div class="wrapper">
  {#await workshops}
    <p>Loading...</p>
  {:then workshops}
    {#if !workshops || workshops.length == 0}
      <p class="empty">{$t("workshop.empty")}</p>
    {:else}
      {#each workshops as workshop (workshop._id)}
        <Workshop
          {workshop}
          {registrations}
          on:unregister={handleUnregister}
          on:register={handleRegister}
          on:loginAndRegister={handleLoginAndRegister}
        />
      {/each}
    {/if}
  {:catch error}
    <p>ERROR: {error}</p>
  {/await}
</div>

<style>
  .wrapper {
    margin: 48px 0;
  }

  .empty {
    color: #999;
    font-size: 20px;
    margin: 64px 0;
  }

  @media only screen and (min-width: 600px) {
    .empty {
      margin: 160px 0;
      font-size: 32px;
    }
  }
</style>
